import React, { useMemo, useState } from 'react';
import { Input } from './ui/input';
import { Tag, Plus } from 'lucide-react';

const fold = (t) => (t || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();

export const CategoryInput = ({ value, onChange, categories }) => {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(0);
  const options = useMemo(() => {
    const q = fold(value);
    return categories.filter((c) => fold(c).includes(q) && fold(c) !== q).slice(0, 8);
  }, [value, categories]);
  const exists = categories.some((c) => fold(c) === fold(value));

  const choose = (c) => { onChange(c); setOpen(false); };
  const onBlur = () => {
    setTimeout(() => setOpen(false), 120);
    const match = categories.find((c) => fold(c) === fold(value));
    if (match && match !== value) onChange(match);
  };
  const onKeyDown = (e) => {
    if (!open || options.length === 0) return;
    if (e.key === 'ArrowDown') { e.preventDefault(); setActive((a) => (a + 1) % options.length); }
    if (e.key === 'ArrowUp') { e.preventDefault(); setActive((a) => (a - 1 + options.length) % options.length); }
    if (e.key === 'Enter') { e.preventDefault(); choose(options[active]); }
    if (e.key === 'Escape') setOpen(false);
  };

  return (
    <div style={{ position: 'relative' }}>
      <Input value={value} autoComplete="off" placeholder="Digite ou escolha uma categoria"
        onChange={(e) => { onChange(e.target.value); setOpen(true); setActive(0); }}
        onFocus={() => setOpen(true)} onBlur={onBlur} onKeyDown={onKeyDown} data-testid="book-category-input" />
      {open && (options.length > 0 || (value.trim() && !exists)) && (
        <div data-testid="category-suggestions" style={{ position: 'absolute', top: 'calc(100% + 4px)', left: 0, right: 0, background: 'white', border: '1px solid #e2e8f0', borderRadius: 8, boxShadow: '0 8px 24px rgba(0,0,0,0.12)', zIndex: 50, overflow: 'hidden' }}>
          {options.map((c, i) => (
            <button key={c} type="button" onMouseDown={(e) => { e.preventDefault(); choose(c); }} onMouseEnter={() => setActive(i)}
              data-testid={`category-option-${i}`}
              style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%', padding: '0.55rem 0.75rem', border: 'none', background: i === active ? '#f0fafa' : 'white', cursor: 'pointer', textAlign: 'left', fontSize: '0.875rem', color: '#2D3748' }}>
              <Tag className="w-3.5 h-3.5" style={{ color: '#68AAB0' }} />{c}
            </button>
          ))}
          {value.trim() && !exists && (
            <div data-testid="category-new-hint" style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '0.55rem 0.75rem', fontSize: '0.8rem', color: '#718096', borderTop: options.length ? '1px solid #edf2f7' : 'none' }}>
              <Plus className="w-3.5 h-3.5" />Nova categoria: <strong style={{ color: '#2D3748' }}>{value.trim()}</strong>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
